import { render, staticRenderFns } from "./ClientDetails_Details.vue?vue&type=template&id=c144b40c&"
import script from "./ClientDetails_Details.vue?vue&type=script&lang=js&"
export * from "./ClientDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports